const formApplyNow = $('.ns-apply-now-form');
const gaSimplePush = (data, status, language) => {
    if (typeof data.event === 'undefined') {
        data.event = 'addEvents_makeConversions';
    }

    if (typeof data.conversion_step === 'undefined') {
        data.conversion_step = status + '_' + language;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

const handleSubmit = () => {
    grecaptcha.ready(() => {
        grecaptcha.execute(window.SiteKey, {action: `ApplyNow${location.pathname.replace(/[^A-Za-z\/_]/g, `_`)}`}).then((token) => {
            const formData = new FormData(formApplyNow[0]);
            formData.append('recaptcha', token);
            const xhr = new XMLHttpRequest();
            xhr.onload = () => {
                const data = JSON.parse(xhr.response);

                if (data.modelValidationErrors.length === 0) {
                    // To prevent ad blockers from blocking user redirects, setTimeout is used
                    setTimeout(
                        () => document.location.href = formApplyNow[0].dataset.actionSuccess,
                        5000
                    );
                    gaSimplePush({
                        'conversion_name': window.conversionName,
                        'conversion_step': data.params.conversion_step,
                        'formCountry': data.params.formCountry,
                        'formTurnover': data.params.formTurnover,
                        'conversion_param': data.params.conversion_param,
                        'eventCallback': () => {
                            document.location.href = formApplyNow[0].dataset.actionSuccess;
                        },
                    }, 'Success', 'en_EN');

                    return false;
                } else {
                    for (const modelValidationErrorKey in data.modelValidationErrors) {
                        const helpBlock = formApplyNow[0].querySelector(
                            `.field-nsapplynow-${modelValidationErrorKey} .help-block`
                        );
                        helpBlock.textContent = data.modelValidationErrors[modelValidationErrorKey][0];
                    }

                    gaSimplePush({
                        'conversion_name': window.conversionName,
                        'formCountry': data.params.formCountry,
                        'formTurnover': data.params.formTurnover,
                        'conversion_param': data.params.conversion_param,
                    }, 'Error', 'en_EN');

                    return false;
                }
            };
            xhr.open('POST', formApplyNow.attr(`action`));
            xhr.send(formData);
        });
    });

    return false;
}

const init = () => {
    if (!formApplyNow) {
        return;
    }

    formApplyNow.on('beforeSubmit', handleSubmit);
}

window.addEventListener('DOMContentLoaded', init, false);
